import { BaseButton } from './'

/** Renders a link that looks like a button */
export function LinkButton({ children, ...rest }) {
    return (
        <BaseButton TagName="a" {...rest}>
            {children}
        </BaseButton>
    )
}
